// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"236243ac","270":"be3916c4","404":"2db878b2","453":"8353c9c7"}[chunkId] + ".chunk.js";
};